
import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  UserControlList: (param) => {   // 商户中心-用户管理列表
    return GET('/merchant/customInviteeRel/findPersonList', param)
  },
  UserControlExport: (param, rsType) => {   // 商户中心-用户管理-导出
    return GETPDF('/merchant/customInviteeRel/findPersonListExport', param, rsType);
  },
  PersonSendInvite: (param) => {   // 商户中心-用户管理列表-发送签约邀请个人
    return GET('/merchant/custom/sendInvitation', param)
  },
  BatchSendInvite: (param) => {   // 商户中心-用户管理列表-发送签约邀请批量
    return POST('/merchant/custom/sendAllInvitation', param)
  },
  MerchantRegulate: (param) => {   // 商户中心-商户管理
    return GET('/merchant/custom/getCustomInfo', param)
  },
  UpdateAliasName: (param) => {   // 商户中心-商户管理-设置别名
    return POST('/merchant/custom/updateAliasName', param)
  },
  applyAliPayRecharge: () => {   // 商户中心-支付宝授权
    return GET('/merchant/account/applyAliPayRecharge')
  },
  getAliPaySignStatus: () => {   // 商户中心-支付宝授权状态查询
    return GET('/merchant/account/getAliPaySignStatus')
  },
  queryAccountTypes: () => {   // 充值记录-可充值的账户类型
    return GET('/merchant/account/queryAccountTypes')
  },
  sendAgainInvitation: (param) => {   // 用户管理批量上传
    return POST('/merchant/custom/sendAgainInvitation', param)
  },
  mailUpdateInfo: (param) => {   // 修改提醒信息
    return POST('/merchant/noticeMail/updateInfo', param)
  },
  invitationLink: (param) => {   // 生成邀请链接
    return GET('/merchant/customInviteeRel/generateInvitationLink', param)
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/individual-center.js